import { useRef } from 'preact/hooks';
import { useSize } from '../hooks/PRIVATE_useSize';

type Props = {
  children: (width: number, height: number) => JSX.Element;
  width: string;
  height: string;
};

const TrackResizeContainer = ({ children, width, height }: Props) => {
  const content =
    !isFixedLength(width) || !isFixedLength(height) ? (
      <TrackResizeOnContainer width={width} height={height}>
        {children}
      </TrackResizeOnContainer>
    ) : (
      <div style={{ width, height }}>
        {children(fixedLengthToNumber(width), fixedLengthToNumber(height))}
      </div>
    );
  return content;
};

const TrackResizeOnContainer = ({ children, width, height }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const size = useSize(ref, { box: 'border-box' });

  return (
    <div ref={ref} style={{ width, height }}>
      {size && children(size.width, size.height)}
    </div>
  );
};

const isFixedLength = (length: string) => length.endsWith('px') || length === '0';
const fixedLengthToNumber = (length: string) =>
  length === '0' ? 0 : Number(length.substring(0, length.length - 2));

export { TrackResizeContainer };
